import './styles/index.css'

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import App from './App'

const mobileUserAgentRegExp = /Mobi|Android|iPhone|iPad|iPod/i

const initMobileConsole = () => {
  const isDevAppEnv = import.meta.env.VITE_APP_ENV === 'dev'
  if (!isDevAppEnv) {
    return
  }

  if (!mobileUserAgentRegExp.test(navigator.userAgent)) {
    return
  }

  void import('eruda').then(({ default: eruda }) => {
    if ((window as typeof window & { __ERUDA_INITIALIZED__?: boolean }).__ERUDA_INITIALIZED__) {
      return
    }

    eruda.init()
    ;(window as typeof window & { __ERUDA_INITIALIZED__?: boolean }).__ERUDA_INITIALIZED__ = true
  })
}

initMobileConsole()

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
